import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const CampaignNameFilter: any = (
  props: any
) => {
  const { campaignName, handleCampaignNameChange, isCampaignNameEnabled, campaignNameError } = props;

  useEffect(() => {
    if (!isCampaignNameEnabled) {
      handleCampaignNameChange({ target: { value: "", name: "campaignName" } } as any, "campaignName");
    }
  }, [isCampaignNameEnabled]);

  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          campaignName: campaignName,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="campaignName"
            placeholder="Enter Campaign Name"
            optional={false}
            disabled={false}
            value={campaignName}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleCampaignNameChange(e, "campaignName")
            }
          />
          {campaignNameError && <div className="error-text">{campaignNameError}</div>}
        </Form>
      </Formik>
    </div>
  );
};

export default CampaignNameFilter;
